
export const STORAGE_KEYS = {
  ID_TOKEN: 'acad_id_token',
  ACCESS_TOKEN: 'acad_access_token',
  REFRESH_TOKEN: 'acad_refresh_token',
} as const;

export const API_CONFIG = {
  TIMEOUT_MS: 30_001,
  DEFAULT_REGION: 'ap-southeast-2',
} as const;

export const PAGINATION = {
  DEFAULT_PAGE_SIZE: 20,
} as const;

export const AUDIT_CONFIG = {
  PAGE_SIZE: 15,
  AUTO_REFRESH_INTERVAL_MS: 30_000,
  CSV_FILENAME_PREFIX: 'audit-log-',
} as const;

export const USER_MANAGEMENT_CONFIG = {
  PAGE_SIZE: 5,
} as const;

export const AUTH_CONFIG = {
  DEFAULT_ROLE: 'researcher',
  MFA_CODE_LENGTH: 6,
} as const;
